import React, { useCallback, useRef, useState } from 'react'
import { Card } from './Card'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import plus from "../../svgs/plus-white.svg";
import Icon from '../Icon/Icon'
import ConfirmationDialog from '../ConfirmDialog';

const DragableCard = (props) => {
    const fileInputRef = useRef();
    const [showConfirm, setShowConfirm] = useState(false);

    const cards = props.data || [];
    const uploads = props.uploads || [];

    const moveCard = useCallback((dragIndex, hoverIndex) => {
        const updated = [...cards];
        const [removed] = updated.splice(dragIndex, 1);
        updated.splice(hoverIndex, 0, removed);
        props.handleReorder(updated, props.index);
    }, [props.index, cards]);

    const onDropCard = useCallback(() => {
        if (props.onReorderComplete) props.onReorderComplete();
    }, [props.onReorderComplete]);

    const renderCard = useCallback((card, index) => {
        return (
            <Card
                key={card.link + index}
                index={index}
                card={card}
                moveCard={moveCard}
                onDrop={onDropCard}
                remove={props.readOnly ? null : onRemove}
                readOnly={props.readOnly}
                type={props.type}
                standardPages={props.standardPages}
            />
        )
    }, [props.type, props.standardPages, props.readOnly, cards.length, moveCard, onDropCard]);

    const validateSelectedFile = (event) => {
        const selectedFile = event.currentTarget.files[0];
        if (!selectedFile) return;
        fileInputRef.current.value = null;
        const fileSize = selectedFile.size / 1000000;
        if (fileSize > 20) {
            props.setState({ error: 'Maximum file size exceeded (20MB)' });
            return;
        }
        if (props.onUpload) props.onUpload(selectedFile);
    }

    const onRemove = (card) => { setShowConfirm(card); }

    const remove = (card) => {
        const filtered = cards.filter(c => c.link !== card.link);
        props.handleChangeFile(filtered, props.index);
        if (props.onRemoveCard) props.onRemoveCard(card);
        setShowConfirm(false);
    }

    const onCloseConfirm = (val) => {
        if (val) remove(showConfirm);
        else setShowConfirm(false);
    }

    return (
        <React.Fragment>
            <ConfirmationDialog open={!!showConfirm} onClose={onCloseConfirm} content="Remove this page from the proposal?" />
            <DndProvider backend={HTML5Backend}>
                <div className="DragableCard_grid">
                    {cards.map((card, i) => renderCard(card, i))}
                    {uploads.map((u) => (
                        <div key={u.id} className="DragableCard_skeleton">
                            <svg className="DragableCard_progress" viewBox="0 0 48 48">
                                <circle className="DragableCard_progress_track" cx="24" cy="24" r="20" />
                                <circle
                                    className="DragableCard_progress_fill"
                                    cx="24" cy="24" r="20"
                                    strokeDasharray={`${u.progress * 1.256} 125.6`}
                                />
                            </svg>
                            <span className="DragableCard_progress_text">{u.progress}%</span>
                            <span className="DragableCard_progress_name">{u.fileName}</span>
                        </div>
                    ))}
                    {!props.readOnly && (
                        <div className="DragableCard_add" onClick={() => fileInputRef.current.click()}>
                            <div className="DragableCard_add_icon">
                                <Icon svg={plus} />
                            </div>
                            <span className="DragableCard_add_label">Add Page</span>
                        </div>
                    )}
                </div>
            </DndProvider>
            <input className='hidden' type="file" ref={fileInputRef} accept="image/png, image/jpeg, image/jpg, .svg" onChange={validateSelectedFile} />
        </React.Fragment>
    )
}
export default DragableCard;
